import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { FileUploader } from 'ng2-file-upload';
import { MatDatepicker, MatDatepickerModule, MatDatepickerToggle } from '@angular/material/datepicker';
import { CommonModule } from '@angular/common';
import { matFormFieldAnimations, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatToolbar } from '@angular/material/toolbar';


@Component({
  selector: 'app-add-licence-management',
  templateUrl: './add-licence-management.component.html',
  styleUrls: ['./add-licence-management.component.scss'],
  standalone: true,
  imports: [MatDatepicker,CommonModule,MatDatepickerToggle,MatDatepickerModule,MatLabel,MatFormFieldModule,ReactiveFormsModule,MatToolbar]
})
export class AddLicenceManagementComponent implements OnInit {
  public clientListingUrl = BaseUrlConstantsService.CLIENTS_LISTING;
  public createLicenceUrl = BaseUrlConstantsService.LICENCE_URL;
  public editLicenceUrl = BaseUrlConstantsService.LICENCE_URL;
  public updateLicenceUrl = BaseUrlConstantsService.LICENCE_URL;
  public fileUploadUrl = BaseUrlConstantsService.FILE_UPLOAD;
  public clientList: any;
  public uForm: any;
  public uploader: FileUploader;
  public clientID: any;
  public companyName: any;
  public pageRef: string;
  public editLicenceID: any;
  public functionType: string;
  public saveButton: string;
  public addButton: boolean;
  public pageTitle: string;
  public _imgUrl: any;
  public fileName: any = '';
  public imagePath: any;
  public showCancelBtn: boolean;
  public showEditUsertxt: string;
  public percentDone: any;
  public showViewButton: boolean;
  public pdffile: string;
  public breadcrumbsArray: any = [{
    page_ref: 'licence-management',
    page_title: 'Licence management'
  }, {
    page_ref: 'add-licence',
    page_title: 'Add Licence'
  }];

  constructor(
    public router: Router,
    private service: BackendApiService,
    private changeService: ChangeUsersService,
    public activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder) {
    this.uploader = new FileUploader({ url: BaseUrlConstantsService.FILE_UPLOAD, itemAlias: 'photo' });
    activeRoute.queryParams.subscribe(params => {
      this.pageRef = params[`lastPageRef`];
      if (this.pageRef === 'licence-management') {
        this.functionType = params[`functionType`];
        this.editLicenceID = params[`licenceTypeId`];
        if (this.functionType === 'edit') {
          this.saveButton = 'update';
          this.addButton = false;
          this.pageTitle = 'Edit Licence';
          this.getEditInfo(this.editLicenceID);
        } else {
          this.pageTitle = 'Add Licence';
          this.addButton = true;
          this.saveButton = 'save';
        }
      }
    });
  }

  ngOnInit() {
    this.uForm = this.formBuilder.group({
      client_value: new FormControl('', [Validators.required]),
      po_date: new FormControl('', [Validators.required]),
      po: new FormControl('', [Validators.required]),
      number_of_licence: new FormControl('', [Validators.required]),
    });
    this.uploader.onBuildItemForm = (item, form) => {
      form.append('token', localStorage.getItem('token'));
      form.append('id', this.editLicenceID);
    };
    this.uploader.onAfterAddingFile = (file) => { file.withCredentials = false; };
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      if (status === 200) {
        this.service.getData(this.editLicenceUrl + "/" + this.editLicenceID).then(response => {
          if (JSON.parse(JSON.stringify(response)).data.body.length !== 0) {
            this.fileName = JSON.parse(JSON.stringify(response)).data.body.contract_copy;
            this.clientID = JSON.parse(JSON.stringify(response)).data.body.client_id;
            this.service.showSuccess('Saved successfully');
          }
        });
      } else {
        this.service.showError('Upload unsuccessfully');
      }
    };
    this.getAllClients();
  }

  viewLicense(pdf) {
    window.open(pdf, '_blank');
  }

  upload(files: any) {
    if (files[0].type === 'application/pdf') {
      if (files[0].name !== undefined && files[0].name === '') {
        this.fileName = '';
      } else {
        this.showCancelBtn = true;
        this.fileName = files[0].name;
        this.uploader.uploadAll();
        this.uploader.onProgressItem = (progress: any) => {
          this.percentDone = progress['progress'];
        };
      }
    } else {
      this.service.showError('Invalid file format!');
    }
  }


  async getAllClients() {
    this.changeService.loader(true);
    this.service.getData(this.clientListingUrl + "CLIENT").then(async (res) => {
      this.changeService.loader(false);
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        this.clientList = JSON.parse(JSON.stringify(res)).data.body;
      } else {
        this.service.showError('Something went wrong.');
      }
    });
  }

  async getEditInfo(licenceId) {
    this.service.getData(this.editLicenceUrl + '/' + licenceId).then(async (res) => {
      if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
        let editLicenceInfo = JSON.parse(JSON.stringify(res)).data.body;
        this.pdffile = editLicenceInfo.contract_copy;
        if (editLicenceInfo.contract_copy === null) {
          this.showViewButton = false;
        } else {
          this.showViewButton = true;
        }
        this.uForm = this.formBuilder.group({
          client_value: new FormControl(parseInt(editLicenceInfo.client_id), [Validators.required]),
          po_date: new FormControl(editLicenceInfo.po_date, [Validators.required]),
          po: new FormControl(editLicenceInfo.po, [Validators.required]),
          number_of_licence: new FormControl(editLicenceInfo.number_of_licence, [Validators.required]),
        });
      };
    }, err => {
      this.service.showError(err);
    });
  }


  async goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  async selectedClient(clientId, companyName) {
    this.clientID = clientId;
    this.companyName = companyName;
  }

  async saveDevice() {
    const body = {
      user_id: localStorage.getItem("user_id"),
      company_name: this.companyName,
      client_id: this.clientID,
      number_of_licence: this.uForm.value.number_of_licence,
      po: this.uForm.value.po,
      po_date: this.uForm.value.po_date
    };
    if (this.functionType === 'edit') {
      if (this.uForm.dirty && this.uForm.valid) {
        this.changeService.loader(true);
        await this.service.putData(this.updateLicenceUrl + '/' + this.editLicenceID, body).then(res => {
          this.changeService.loader(false);
          const result = JSON.parse(JSON.stringify(res))
          if (result.data.status === 'success') {
            this.service.showSuccess('licence updated successfully');
            this.router.navigate(['/licence-management']);
          } else {
            this.service.showError('Something went wrong.');
          }
        })
      } else {
        if (this.fileName !== '') {
          this.service.showSuccess('licence updated successfully');
          this.router.navigate(['/licence-management']);
        }
      }
    } else {
      if (this.uForm.dirty && this.uForm.valid) {
        this.changeService.loader(true);
        await this.service.postData(this.createLicenceUrl, body).then(res => {
          this.changeService.loader(false);
          const result = JSON.parse(JSON.stringify(res))
          if (result.data.status === 'success') {
            this.service.showSuccess('licence registered successfully');
            this.router.navigate(['/licence-management']);
          } else {
            this.service.showError('Something went wrong.');
          }
        })
      };
    }
  }
}